import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  CardHeader,
  Table,
  ModalHeader,
  ModalBody,
  Modal,
  Progress,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import { useLocation, useParams } from "react-router-dom";

const ProfitLoss = (props) => {
  const handleDownload = () => {
    alert("Downloading ProfitLoss...");
  };

  return (
    <>
      <div className="page-content">
        <Container>
          <Card>
            <CardBody>
              <div className="d-flex gap-2 text-end justify-content-end">
                <div className="d-flex justify-content-center justify-content-md-end mb-3">
                  <Button color="success" onClick={handleDownload}>
                    Download
                  </Button>
                </div>
              </div>
              <CardHeader style={{ textAlign: "center", fontWeight: "bold" }}>
                <p>नमुना बचत तथा ऋण सहकारी संस्था लि.</p>
                <p>सुनपा ४, धादिकोट</p>
                <p>नाफा नोक्सान हिसाब</p>
                <p>आषाढ़ देखि श्रावण मासन्तको</p>
              </CardHeader>
              <table className="table table-bordered table-stripped responsive">
                <thead>
                  <tr className="secondary">
                    <th className="text-start">विवरण</th>
                    <th className="text-start">अनुसूची</th>
                    <th className="text-start">यस वर्ष (रु)</th>
                    <th className="text-start">गत वर्ष (रु)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-start">आम्दानी</td>
                    <td>1</td>
                    <td className="text-end">182,172,339.55</td>
                    <td className="text-end">129,927,414.08</td>
                  </tr>
                  <tr>
                    <td className="text-start">ब्याज आम्दानी</td>
                    <td>12</td>
                    <td className="text-end">182,172,339.55</td>
                    <td className="text-end">129,927,414.08</td>
                  </tr>
                  <tr>
                    <td className="text-start"> न्यून ब्याज खर्च</td>
                    <td>13</td>
                    <td
                      style={{ textDecoration: "underline" }}
                      className="text-end"
                    >
                      129,927,414.08
                    </td>
                    <td
                      style={{ textDecoration: "underline" }}
                      className="text-end"
                    >
                      5,933,499.07
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      खुद ब्याज आम्दानी
                    </td>
                    <td></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      129,927,414.08
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      5,933,499.07
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td className="text-start">अन्य आम्दानी</td>
                    <td>14</td>
                    <td
                      style={{ textDecoration: "underline" }}
                      className="text-end"
                    >
                      129,927,414.08
                    </td>
                    <td
                      style={{ textDecoration: "underline" }}
                      className="text-end"
                    >
                      2,045,781,236.51
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      कुल सञ्चालन आम्दानी
                    </td>
                    <td></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      5,532,155.16
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      5,933,499.07
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">कर्मचारी खर्च</td>
                    <td>15</td>
                    <td className="text-end">5,532,155.16</td>
                    <td className="bold text-end">5,933,499.07</td>
                  </tr>
                  <tr>
                    <td className="text-start">प्रशासनिक खर्च </td>
                    <td>5</td>
                    <td className="text-end">6,854,588.59</td>
                    <td className="bold text-end">5,933,499.07</td>
                  </tr>
                  <tr>
                    <td>हास कट्टि</td>
                    <td></td>
                    <td className="text-end">1,702,661.45</td>
                    <td className="bold text-end">5,933,499.07</td>
                  </tr>
                  <tr>
                    <td className="text-start">उच्च</td>
                    <td></td>
                    <td
                      style={{ textDecoration: "underline" }}
                      className="text-end"
                    >
                      2,227,438,568.73
                    </td>
                    <td
                      style={{ textDecoration: "underline" }}
                      className="text-end"
                    >
                      5,933,499.07
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      संचालन वचत
                    </td>
                    <td></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      2,227,438,568.73
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      5,933,499.07
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      गत वर्षको नोक्सान सम्योजन
                    </td>
                    <td></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    ></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    ></td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      यस वर्षको आयकर अगिको नफा
                    </td>
                    <td></td>
                    <td style={{ fontWeight: "bold" }} className="text-end">
                      2,227,438,568.73
                    </td>
                    <td style={{ fontWeight: "bold" }} className="text-end">
                      5,933,499.07
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">आयकर व्यवस्था</td>
                    <td></td>
                    <td className="text-end">2,227,438,568.73</td>
                    <td className="bold text-end">5,933,499.07</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      खुद नफा (नोक्सान)
                    </td>
                    <td></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      2,227,438,568.73
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="text-end"
                    >
                      5,933,499.07
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default ProfitLoss;
